import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiFlipCardBack]',
    standalone: false
})
export class FlipCardBackDirective {
  @HostBinding('class') hostClass = 'flip-card-back';
}
